import React from "react";
import { Collab, PaymentSettings } from "@resources";
import { GuarantorOption } from "@common";
import { useNavigate } from 'react-router-dom';

const MyAccount = () => {

    const navigate = useNavigate();

    return (
        <div className="page-content-wrapper">
            <div className="flex flex-col w-full gap-y-6 mb-7">
                <div className="bg-sb-bg shadow-sb rounded-lg py-3 px-6 cursor-pointer" onClick={() => navigate(`/payment-method-settings`)}>
                    <div className="flex">
                        <div className="flex flex-col w-3/5 gap-y-2">
                            <span className="font-semibold text-xl">Payment Settings</span>
                            <span className="text-gray-500">Manage payment methods and control autopay and payment date.</span>
                        </div>
                        <div className="flex w-2/5">
                            <PaymentSettings className="w-32 m-auto" />
                        </div>
                    </div>
                </div>
                <GuarantorOption>
                    <div className="bg-sb-bg shadow-sb rounded-lg py-3 px-6 cursor-pointer" onClick={() => navigate(`/manage-payors`)}>
                        <div className="flex">
                            <div className="flex flex-col w-3/5 gap-y-2">
                                <span className="font-semibold text-xl">Manage Payors</span>
                                <span className="text-gray-500">Add and delete payors, and manage active payors to set their payment dates and payment amounts.</span>
                            </div>
                            <div className="flex w-2/5">
                                <Collab className="w-32 m-auto" />
                            </div>
                        </div>
                    </div>
                </GuarantorOption>
                {/* <GuarantorOption>
                    <div className="bg-sb-bg shadow-sb py-3 px-6 cursor-pointer" onClick={() => navigate(`/subscription-settings`)}>
                        <div className="flex">
                            <div className="flex flex-col w-3/5 gap-y-2">
                                <span className="font-semibold text-xl">Subscription Settings</span>
                                <span className="text-gray-500">Manage auto-enroll or find information about your subscription.</span>
                            </div>
                            <div className="flex w-2/5">
                                <SubscriptionSettigns className="w-32 m-auto" />
                            </div>
                        </div>
                    </div>
                </GuarantorOption> */}
            </div>
        </div>

    );
};

export default MyAccount;